import styled, { keyframes } from "styled-components";

import { ReactComponent as Wave2Svg } from "../../assets/sea-wave-2.svg";
import { ReactComponent as Wave3Svg } from "../../assets/sea-wave-3.svg";
import { ReactComponent as Wave4Svg } from "../../assets/sea-wave-4.svg";
import { ReactComponent as Wave5Svg } from "../../assets/sea-wave-5.svg";
import { ReactComponent as ScallopSvg } from "../../assets/scallop.svg";
import { ReactComponent as Algae1Svg } from "../../assets/algae-1.svg";
import { ReactComponent as Algae2Svg } from "../../assets/algae-2.svg";
import { ReactComponent as Algae3Svg } from "../../assets/algae-3.svg";
import { ReactComponent as CrabSvg } from "../../assets/crab.svg";
import { ReactComponent as SeahorseSvg } from "../../assets/seahorse.svg";
import { ReactComponent as RedFishSvg } from "../../assets/red-fish.svg";
import { ReactComponent as BubblesSvg } from "../../assets/bubbles.svg";
import { ReactComponent as JellyfishSvg } from "../../assets/jellyfish-smile.svg";
import { ReactComponent as OctopusSvg } from "../../assets/octopus-smile.svg";


const float = keyframes`
  0% { transform: translateY(0); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0); }
`;

const waveAnimation = keyframes`
  0% { transform: translateX(0); }
  50% { transform: translateX(-15px); }
  100% { transform: translateX(0); }
`;

const Header = styled.div`
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: calc(15vh + env(safe-area-inset-top, 20px)); /* add safe area */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  // padding-top: calc(1.5vh + env(safe-area-inset-top, 20px)); /* push content below notch */
  padding-top: calc(3vh + env(safe-area-inset-top, 20px)); /* push content below notch */
  padding-left: 1.5vh;
  padding-right: 1.5vh;
  z-index: 10;
  padding-top: var(--sat);
  padding-bottom: var(--sab);
  @media (max-width: 768px) {
    padding-top: calc(3vh + env(safe-area-inset-top, 20px)); /* increase for mobile */
  }

`;


const LivesContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding-top: 1.6%;
`;

const Wave5 = styled(Wave5Svg)`
  width: 100vw;
  position: fixed;
  bottom: 0px;
  left: 0;
  height: 20vh;
  animation: ${waveAnimation} 8s ease-in-out infinite;
  @media (max-width: 480px) {
    height: 12.3vh;
    bottom: 16vh;
  }
`;

const Wave4 = styled(Wave4Svg)`
  width: 100vw;
  height: 20vh;
  position: fixed;
  bottom: 0vh;
  left: 0;
  animation: ${waveAnimation} 7s ease-in-out infinite;
  @media (max-width: 480px) {
    height: 12.3vh;
    bottom: 16vh;
  }
`;

const Wave3 = styled(Wave3Svg)`
  width: 100vw;
  height: 20vh;
  position: fixed;
  bottom: 0vh;
  left: 0;
  animation: ${waveAnimation} 5s ease-in-out infinite;
  @media (max-width: 480px) {
    height: 25vh;
    bottom: 0vh;
  }
`;

const Wave2 = styled(Wave2Svg)`
  width: 100vw;
  height: 20vh;
  position: fixed;
  bottom: 0vh;
  left: 0;
  @media (max-width: 480px) {
    height: 1vh;
    bottom: 16vh;
  }
`;

const BinContainer = styled.div`
  position: fixed;
  bottom: 7.5vh; // default bottom for desktop
  width: 100%;
  display: flex;
  justify-content: space-around; // evenly space bins
  align-items: flex-end;

  @media (max-width: 480px) {
    bottom: 27vh; // move up for mobile
    flex-wrap: wrap; // wrap bins if screen too small
  }
`;

// Each bin gets responsive sizing
const BinBox = styled.div`
  img {
    width: auto; // keep aspect ratio
    max-height: 25vh; // max height for desktop
  }

  @media (max-width: 480px) {
    img {
      height: 12vh; // smaller height for mobile
      max-width: 20vw;
    }
  }
`;

const BlackBinBox = styled(BinBox)``;
const RecycleBinBox = styled(BinBox)``;
const CompostBinBox = styled(BinBox)``;
const YardBinBox = styled(BinBox)`
bottom: 7.5vh;`;
const SpecialBinBox = styled(BinBox)`
bottom: 7.5vh;`;


const GameItem = styled.div`
  position: fixed;
  top: 12%;
  left: 2%;
  img {
    height: 10vh;
    max-width: 5vw;
  }
  @media (max-width: 480px) {
    top: 18%;
    left: 3%;
    img {
      max-height: 12vh; // smaller height for mobile
      max-width: 20vw;
    }
  }
`;

const Algae1 = styled(Algae1Svg)`
  position: fixed;
  left: 81.66%;
  right: 15.33%;
  bottom: -1%;
  z-index: 900;
  @media (max-width: 480px) {
    bottom: 8vh;
  }
`;

const Algae2 = styled(Algae2Svg)`
  position: fixed;
  left: 8.79%;
  right: 83.42%;
  bottom: -1%;
  z-index: 900;
  animation: ${waveAnimation} 5s ease-in-out infinite;
  @media (max-width: 480px) {
  }
`;

const Algae3 = styled(Algae3Svg)`
  position: fixed;
  left: 43.3%;
  right: 40.37%;
  bottom: -1%;
  z-index: 900;
  
`;

const Scallop = styled(ScallopSvg)`
  position: fixed;
  width: 8.1vw;
  height: 10.9vh;
  right: 1.3vw;
  bottom: 1.4vw;
  z-index: 900;
  animation: ${float} 3s ease-in-out infinite;
  @media (max-width: 480px) {
    height: 8.3vh;
    right: 2.3vw;
    width: 10.1vw;
  }
`;

const Crab = styled(CrabSvg)`
  position: fixed;
  width: 9.4vw;
  height: 12.3vh;
  left: 1.3vw;
  bottom: 1.8vw;
  z-index: 900;
  animation: ${float} 5s ease-in-out infinite;
  @media (max-width: 480px) {
    height: 6.3vh;
  }
`;

const Seahorse = styled(SeahorseSvg)`
  position: fixed;
  left: 16.86%;
  right: 76.57%;
  bottom: -3%;
  z-index: 900;
  animation: ${float} 7s ease-in-out infinite;
`;

const Bubbles = styled(BubblesSvg)`
  position: fixed;
  width: 5.2vw;
  height: 12.1vh;
  right: 15%;
  bottom: 6.5vw;
  z-index: 901;
  animation: ${float} 5s ease-in-out infinite;
  @media (max-width: 480px) {
    height: 6.3vh;
  }
`;

const RedFish = styled(RedFishSvg)`
  position: fixed;
  left: 72.53%;
  right: 21.87%;
  bottom: 0.79%;
  z-index: 900;
  animation: ${waveAnimation} 9s ease-in-out infinite;
  &:hover {
    transform: scale(1.1) rotate(-2deg);
    cursor: pointer;
  }
`;

const Octopus = styled(OctopusSvg)`
  position: fixed;
  right: 22.67%;
  bottom: 10%;
  animation: ${float} 3s ease-in-out infinite;
`;

const Jellyfish = styled(JellyfishSvg)`
  position: fixed;
  width: 6.8vw;
  height: 8.3vh;
  left: 25%;
  bottom: 10%;
  z-index: 900;
  animation: ${waveAnimation} 5s ease-in-out infinite;
  transform: rotate(-10deg);
  @media (max-width: 480px) {
    height: 6.3vh;
  }
`;

const ItemText = styled.h2`
  position: fixed;
  bottom: 2%;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
  z-index: 1000;

  font-family: Bungee;
  font-style: normal;
  font-weight: normal;
  font-size: 6vh;
  line-height: 8vh;
  color: #ffffff;
  text-shadow: 4px 4px 4px rgba(0, 0, 0, 0.25);

  width: 90%;
  max-width: 800px;
  text-align: center;
  white-space: nowrap; /* prevents text from splitting into multiple lines */
  overflow: hidden;
  text-overflow: ellipsis; /* optional: adds "..." if text is too long */

  @media (max-width: 768px) {
    font-size: 4.5vh;
    line-height: 6vh;
  }

  @media (max-width: 480px) {
    font-size: 3vh;
    line-height: 4.5vh;
    bottom: 18vh; /* adjust for smaller screens */
  }
`;



export {
  Header,
  BinContainer,
  LivesContainer,
  Wave5,
  Wave4,
  Wave3,
  Wave2,
  BlackBinBox,
  RecycleBinBox,
  CompostBinBox,
  GameItem,
  Algae1,
  Algae2,
  Algae3,
  Scallop,
  Crab,
  Seahorse,
  Bubbles,
  RedFish,
  Octopus,
  Jellyfish,
  ItemText,
  SpecialBinBox,
  YardBinBox
};
